pyzel.vimeo = {

	// TO-DO: cache the token - now is hardcoded
	token : '',

	get_token: function(){

		return $.when(

			$.ajax({

				url: 'https://api.vimeo.com/oauth/authorize/client',
				method: 'post',
				data: {

					grant_type: "client_credentials"

				},
	  			beforeSend: function (xhr) {
	    			xhr.setRequestHeader ("Authorization", "Basic " + btoa('84fe85942b9796e7be2d33a355b6144fbf728d3a'+ ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA' ));
				}			

			}).done( function( r ){

				console.log( r.access_token );

				pyzel.vimeo.token = r.access_token;				

			})

		)	
			
	},

	get_image: function( video_id ){				

		//pyzel.vimeo.get_token().then( function(){	

		return $.when(	

			$.ajax({

					url: 'https://api.vimeo.com/videos/'+video_id+'/pictures',
					method: 'get',
					beforeSend: function(xhr){
	            		xhr.setRequestHeader('Authorization', 'bearer 1670850b196f3a3d4ab6bb170190b879'); // does the token expire? if not, hardcode it..!
	            	}

				}).done( r => {

					//console.log('we got images from vimeo:');
					//console.log( r.data[0].sizes[5].link );
					//video_details['image'] = r.data[0].sizes[5].link;

					//return video_details;

					//dfd.resolve();

					//return video_details;

					//return r.data[0].sizes[5].link;

			})

		)		

		//})		
		
	}

}

/*
pyzel.vimeo.get_token().then( function(){

	let img = pyzel.vimeo.get_image();
	//console.log( img );

});
*/